import { ComponentsModule } from './../../components/components.module';
import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { WebFilterViewPage } from './web-filter-view';

import { MyDatePickerModule } from 'mydatepicker';

@NgModule({
  declarations: [
    WebFilterViewPage,
  ],
  imports: [
    MyDatePickerModule,
    ComponentsModule,
    IonicPageModule.forChild(WebFilterViewPage),
  ],
})
export class WebFilterViewPageModule { }



// WEBPACK FOOTER //
// ./src/pages/web-filter-view/web-filter-view.module.ts